import { useEffect, useState } from "react";
import { getStageColor } from "../../../utils/formattingFns";

export default function StatusCell({
    value,
}: {
    value: string,
}) {
    const [ colors, setColors ] = useState<{
        label: string,
        background: string
    }>({
        label: '#006D77',
        background: '#D5E7E8',
    })

    useEffect(() => {
        if (value) {
            const { label, background } = getStageColor(value);
            setColors({ label, background });
        }
    }, [value]);


    return (
            <div className="flex justify-center items-center gap-2">
                <div style={{ color: colors.label, backgroundColor: colors.background }} className="py-1 px-3 rounded-lg font-semibold text-[12px] text-nowrap capitalize">{value}</div>
            </div>
    )
}